import { useState } from "react";
import { Button } from "antd";
import { menus } from "./config";
import { iconsAndImages } from "../../assets/images/index";
import { useLocation, useNavigate } from "react-router-dom";

export const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <section className="py-2 border-bottom bg-white" style={{ boxShadow: "0 0 10px #7d7d7d", position: "fixed", top: 0, width: "100%", zIndex: "20" }}>
            <div className="container">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2">
                        <img
                            alt="logo"
                            src={iconsAndImages["logo"]}
                            style={{ height: 45, objectFit: "contain" }}
                            loading="lazy"
                        />
                        <div>
                            <h5 className="mb-0 text-color">SRK TRADERS</h5>
                            <p className="gray-color mb-0" style={{ fontSize: 12 }}>
                                TENKASI, TAMIL NADU
                            </p>
                        </div>
                    </div>
                    <div className="d-lg-none">
                        <button
                            className="btn btn-outline-dark"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            ☰
                        </button>
                    </div>
                    <nav className="d-none d-lg-block">
                        <ul className="d-flex gap-4 mb-0 list-unstyled align-items-center">
                            {menus?.map((menu, index) => {
                                const isActive = location.pathname === `${menu?.path}` || location.pathname === "";
                                return (
                                    <li
                                        key={index}
                                        style={{
                                            cursor: "pointer",
                                            fontWeight: isActive ? "700" : "400",
                                            color: isActive ? "#1D3B5F" : "#000"
                                        }}
                                        onClick={() => navigate(menu?.path)}
                                    >
                                        {menu?.name}
                                    </li>
                                );
                            })}
                        </ul>
                    </nav>
                    <div className="d-none d-lg-block" onClick={() => { navigate("/contact") }}>
                        <Button type="primary">Inquire for Bulk Orders</Button>
                    </div>
                </div>

                {isOpen && (
                    <div className="d-lg-none mt-3">
                        <ul className="list-unstyled d-flex flex-column gap-2">
                            {menus?.map((menu, index) => (
                                <li key={index} className="border-bottom pb-2" onClick={() => {
                                    setIsOpen(false);
                                    navigate(menu?.path)
                                }
                                } >
                                    {menu?.name}
                                </li>
                            ))}
                        </ul>

                        <Button type="primary" block onClick={() => {
                            setIsOpen(false);
                            navigate("/contact")
                        }}>
                            Inquire for Bulk Orders
                        </Button>
                    </div>
                )}
            </div>
        </section>
    );
};
